import React from "react";
import { convertInlineStyles } from "../../utils/utils";
import {
  BalanceCardWrapper,
  CryptoExchangeWrapper,
  ExchangeForm,
  ExchangeFormSelect,
  ExchangeFormGroup,
  ExchangeFormWrapper,
  ExchangeWrapper,
  TradingViewWrapper,
  ExchangeFormInput,
  ExchangeFormButton,
} from "./CryptoExchange.styled";
import BalanceCard from "../../components/BalanceCard/BalanceCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDollarSign } from "@fortawesome/free-solid-svg-icons";

const CryptoExchange = () => {
  const cardData = [
    {
      name: "Balance",
      balance: "$0.00",
      icon: <FontAwesomeIcon icon={faDollarSign} />,
    },
    {
      name: "BTC",
      balance: 0,
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 220 220"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_108_3)">
            <path
              d="M220 110C220 131.756 213.549 153.023 201.462 171.113C189.375 189.202 172.195 203.301 152.095 211.627C131.995 219.952 109.878 222.131 88.5401 217.886C67.2022 213.642 47.6021 203.166 32.2183 187.782C16.8345 172.398 6.35804 152.798 2.11367 131.46C-2.13071 110.122 0.0476608 88.0047 8.3733 67.9048C16.6989 47.805 30.7979 30.6253 48.8873 18.5383C66.9767 6.45139 88.2441 0 110 0C139.174 0 167.153 11.5893 187.782 32.2183C208.411 52.8473 220 80.8262 220 110Z"
              fill="#F7931A"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M78.1801 50.2304L103.46 57.0004L109.11 35.9404L121.75 39.3704L116.32 59.5604L126.63 62.3304L132.07 41.9204L144.93 45.3604L139.39 65.8804C139.39 65.8804 160.39 70.5304 165.33 87.6104C170.27 104.69 154.47 113.66 149.59 114C149.59 114 167.99 124.09 161.67 143.94C155.35 163.79 135.95 167.34 115.54 162.79L110 184.07L97.1401 180.63L102.79 159.68L92.5901 156.9L86.9401 178L74.1801 174.57L79.8401 153.57L53.8901 146.57L60.4301 132.05C60.4301 132.05 67.7501 134.05 70.5201 134.71C73.2901 135.37 75.0701 132.49 75.8501 129.61C76.6301 126.73 88.3801 79.0004 89.4901 75.0704C90.6001 71.1404 90.1501 68.0704 85.4901 66.8604C80.8301 65.6504 74.4901 63.7604 74.4901 63.7604L78.1801 50.2304ZM103.68 113.44L96.6801 141.27C96.6801 141.27 131.39 153.8 135.83 136.17C140.27 118.54 103.68 113.44 103.68 113.44ZM106.9 100.24L113.77 74.7404C113.77 74.7404 143.49 80.0604 139.83 94.2504C136.17 108.44 118.65 103 106.9 100.24Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_108_3">
              <rect width="220" height="220" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      name: "ETH",
      balance: 0,
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 220 220"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_108_167)">
            <path
              d="M110 220C170.751 220 220 170.751 220 110C220 49.2487 170.751 0 110 0C49.2487 0 0 49.2487 0 110C0 170.751 49.2487 220 110 220Z"
              fill="#627EEA"
            />
            <path
              d="M113.424 27.5V88.4813L164.966 111.512L113.424 27.5Z"
              fill="white"
              fill-opacity="0.602"
            />
            <path
              d="M113.424 27.5L61.875 111.512L113.424 88.4813V27.5Z"
              fill="white"
            />
            <path
              d="M113.424 151.031V192.467L165 121.111L113.424 151.031Z"
              fill="white"
              fill-opacity="0.602"
            />
            <path
              d="M113.424 192.467V151.024L61.875 121.111L113.424 192.467Z"
              fill="white"
            />
            <path
              d="M113.424 141.44L164.966 111.513L113.424 88.4956V141.44Z"
              fill="white"
              fill-opacity="0.2"
            />
            <path
              d="M61.875 111.513L113.424 141.44V88.4956L61.875 111.513Z"
              fill="white"
              fill-opacity="0.602"
            />
          </g>
          <defs>
            <clipPath id="clip0_108_167">
              <rect width="220" height="220" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      name: "LTC",
      balance: 0,
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 220 220"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_108_9)">
            <path
              d="M110 0C80.9337 0.0847884 53.0891 11.7018 32.581 32.2998C12.0729 52.8979 0.57784 80.793 0.620234 109.86C0.662628 138.926 12.239 166.788 32.8071 187.326C53.3752 207.864 81.2536 219.4 110.32 219.4C139.387 219.4 167.265 207.864 187.833 187.326C208.401 166.788 219.978 138.926 220.02 109.86C220.062 80.793 208.567 52.8979 188.059 32.2998C167.551 11.7018 139.707 0.0847884 110.64 0L110 0Z"
              fill="#345D9D"
            />
            <path
              d="M112 112.46L102.31 145H153.87C154.211 144.983 154.552 145.037 154.87 145.16C155.188 145.28 155.481 145.46 155.73 145.69C155.978 145.927 156.178 146.208 156.32 146.52C156.47 146.833 156.552 147.174 156.56 147.52V148.37L152.07 163.84C151.878 164.574 151.436 165.217 150.82 165.66C150.21 166.108 149.466 166.333 148.71 166.3H69.8102L83.0302 121.3L68.2402 125.78L71.6002 115.47L86.3902 110.98L105 47.6801C105.202 46.9509 105.646 46.3123 106.26 45.8701C106.867 45.4227 107.606 45.1904 108.36 45.2101H128.36C128.701 45.2014 129.041 45.2591 129.36 45.3801C129.683 45.4972 129.978 45.6774 130.23 45.9101C130.483 46.1426 130.684 46.4254 130.82 46.7401C130.964 47.0545 131.042 47.3947 131.05 47.7401V48.6001L115.36 101.95L130.16 97.4601L127 108.2L112 112.46Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_108_9">
              <rect width="220" height="220" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      name: "LINK",
      balance: 0,
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 220 220"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_108_239)">
            <path
              d="M110 220C170.751 220 220 170.751 220 110C220 49.2487 170.751 0 110 0C49.2487 0 0 49.2487 0 110C0 170.751 49.2487 220 110 220Z"
              fill="#2A5ADA"
            />
            <path
              d="M110 41.25L97.6319 48.5031L63.9375 68.3719L51.5625 75.625V144.375L63.9306 151.628L97.9413 171.497L110.309 178.75L122.677 171.497L156.069 151.628L168.438 144.375V75.625L156.069 68.3719L122.368 48.5031L110 41.25ZM76.2987 129.869V90.1312L110 70.2625L143.701 90.1312V129.869L110 149.738L76.2987 129.869Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_108_239">
              <rect width="220" height="220" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      name: "BNB",
      balance: 0,
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 220 220"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_108_74)">
            <path
              d="M110 220C170.751 220 220 170.751 220 110C220 49.2487 170.751 0 110 0C49.2487 0 0 49.2487 0 110C0 170.751 49.2487 220 110 220Z"
              fill="#F3BA2F"
            />
            <path
              d="M83.2975 99.0275L110 72.325L136.716 99.0413L152.254 83.5037L110 41.25L67.76 83.49L83.2975 99.0275ZM41.25 110L56.7875 94.4625L72.325 110L56.7875 125.537L41.25 110ZM83.2975 120.973L110 147.675L136.716 120.959L152.254 136.489L110 178.75L67.76 136.51L67.7394 136.489L83.2975 120.973ZM147.675 110L163.213 94.4625L178.75 110L163.213 125.537L147.675 110ZM125.757 109.986H125.771V110L110 125.771L94.2494 110.027L94.2219 110L94.2494 109.979L97.0062 107.216L98.3469 105.875L110 94.2288L125.764 109.993L125.757 109.986Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_108_74">
              <rect width="220" height="220" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      name: "ADA",
      balance: 0,
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 220 220"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_108_21)">
            <path
              d="M110 220C170.751 220 220 170.751 220 110C220 49.2487 170.751 0 110 0C49.2487 0 0 49.2487 0 110C0 170.751 49.2487 220 110 220Z"
              fill="#0D1E30"
            />
            <g filter="url(#filter0_d_108_21)">
              <path
                d="M108.109 41.6626C111.402 39.9644 115.424 43.8901 113.678 47.1282C112.654 49.7682 108.797 50.4694 106.83 48.4551C104.747 46.5301 105.428 42.7076 108.109 41.6557V41.6626ZM72.6686 45.4163C74.6692 44.6051 77.2061 46.4063 76.9999 48.5582C77.2061 50.8819 74.3186 52.6007 72.2767 51.4938C69.5749 50.4626 69.8842 46.1451 72.6686 45.4163ZM145.255 51.5557C142.127 51.1844 141.632 46.3444 144.636 45.3682C146.974 44.2544 149.119 46.3513 149.462 48.5307C148.967 50.3869 147.386 52.0919 145.255 51.5557ZM80.733 60.2526C84.0811 58.1694 88.8524 61.2701 88.3367 65.0994C88.1649 68.9563 82.9536 71.1976 80.0111 68.5851C77.1649 66.5363 77.598 61.8338 80.733 60.2526ZM131.814 62.4663C133.306 58.6851 139.356 58.5613 141.054 62.2463C142.739 65.1132 140.669 68.6676 137.679 69.6438C133.712 70.3726 129.951 66.1513 131.814 62.4663ZM103.84 69.4307C103.805 66.1719 106.817 63.7519 109.959 63.5251C112.049 63.9376 114.317 64.8107 115.211 66.8801C116.882 69.7401 115.397 73.6657 112.392 74.9788C111.017 75.7351 109.381 75.4532 107.882 75.3638C105.593 74.2638 103.661 72.0844 103.84 69.4307ZM51.1361 74.1744C54.1955 72.3182 58.3205 75.6869 57.1586 78.9594C56.5261 81.7851 52.6624 82.9332 50.4555 81.1319C48.0974 79.4407 48.4686 75.3776 51.143 74.1676L51.1361 74.1744ZM164.312 74.1607C166.904 72.1807 171.187 74.4563 170.871 77.6738C171.05 80.6094 167.344 82.8301 164.773 81.3176C161.94 80.0594 161.645 75.7694 164.312 74.1676V74.1607ZM118.662 80.0113C122.939 78.4988 128.026 80.3069 130.46 84.0676C133.677 88.6532 131.972 95.6382 126.974 98.2713C121.804 101.386 114.249 98.7526 112.33 93.0601C110.165 87.9726 113.327 81.6063 118.656 80.0113H118.662ZM93.548 80.5132C98.2917 78.3132 104.679 80.1557 106.968 84.9269C109.663 89.5744 107.58 96.0438 102.76 98.4432C97.9342 101.145 91.1211 99.0963 88.7905 94.1119C86.1711 89.2857 88.4949 82.7338 93.548 80.5132ZM68.4061 88.9626C68.7705 85.9582 71.6511 83.9988 74.5592 83.7926C76.0759 83.9527 77.4933 84.6227 78.5798 85.6929C79.6663 86.7632 80.3575 88.1704 80.5405 89.6844C80.3342 92.7782 77.9074 95.7894 74.5799 95.7757C70.9155 96.0851 67.7049 92.4963 68.4061 88.9626ZM142.67 84.4526C146.43 82.3007 151.649 85.4288 151.484 89.6776C151.738 94.1807 145.963 97.3501 142.223 94.7101C138.332 92.5101 138.634 86.3226 142.67 84.4526ZM83.3386 100.313C87.7249 99.1238 92.7574 101.159 94.9092 105.133C97.2674 109.134 96.3049 114.689 92.6405 117.631C87.9311 121.935 79.2617 120.203 76.7592 114.331C73.8786 108.948 77.378 101.729 83.3317 100.306L83.3386 100.313ZM130.962 100.293C135.231 99.0894 140.25 100.705 142.546 104.534C145.585 108.914 144.134 115.452 139.617 118.271C134.874 121.55 127.545 119.831 124.932 114.703C121.77 109.402 124.953 101.908 130.962 100.293ZM55.0617 105.284C58.8567 103.874 63.0642 107.993 61.5243 111.698C60.5893 115.067 55.7561 116.318 53.2605 113.829C50.3386 111.492 51.418 106.301 55.0617 105.284ZM157.974 110.66C157.902 109.147 158.432 107.666 159.446 106.541C160.461 105.416 161.878 104.737 163.391 104.651C165.99 105.064 168.52 107.126 168.314 109.911C168.554 113.589 164.051 116.084 160.861 114.359C159.369 113.609 158.606 112.104 157.974 110.66ZM36.3961 107.113C38.6786 106.129 41.5042 108.075 40.9817 110.571C40.858 113.396 36.6161 114.489 35.0624 112.124C33.6874 110.481 34.5124 107.958 36.3961 107.106V107.113ZM180.42 107.051C182.029 105.93 184.614 106.734 185.247 108.584C186.326 110.605 184.346 113.369 182.036 113.032C178.791 113.321 177.746 108.46 180.42 107.051ZM95.7411 120.615C101.75 119.082 108.212 124.011 108.254 130.103C108.639 136.256 102.272 141.708 96.1261 140.291C91.3686 139.535 87.6355 135.025 87.7936 130.302C87.7799 125.778 91.2449 121.571 95.7411 120.615ZM119.542 120.608C125.64 118.931 132.295 123.949 132.199 130.178C132.522 136.214 126.355 141.488 120.333 140.284C114.661 139.569 110.481 133.444 112.062 128.026C112.86 124.424 115.926 121.495 119.542 120.601V120.608ZM73.6449 124.355C77.8661 123.647 81.8261 128.274 80.1142 132.22C78.863 136.428 72.648 137.562 69.898 134.131C66.6805 130.831 69.0867 124.809 73.6449 124.355ZM143.454 124.541C147.221 122.987 151.841 126.191 151.552 130.213C151.704 134.633 145.997 137.686 142.319 135.101C138.146 132.784 138.909 125.957 143.454 124.541ZM162.965 143.791C161.494 141.089 164.168 137.507 167.227 138.009C168.74 137.981 169.805 139.157 170.775 140.147C170.974 141.749 171.311 143.66 169.957 144.891C168.121 147.18 163.962 146.527 162.965 143.791ZM51.1224 138.758C53.9755 136.895 58.0799 139.679 57.4336 142.952C57.0899 145.86 53.3774 147.517 50.9367 145.867C48.3105 144.375 48.4067 140.119 51.1224 138.758ZM107.449 144.829C111.182 143.213 115.94 146.41 115.582 150.453C115.857 154.921 109.979 158.015 106.329 155.334C102.272 153.031 102.953 146.252 107.449 144.829ZM81.3655 150.817C84.5417 149.174 88.8042 152.013 88.5155 155.519C88.6117 158.393 85.7655 160.841 82.878 160.414C80.4924 160.366 78.9386 158.256 78.1686 156.255C78.2099 154.076 79.1242 151.649 81.3655 150.824V150.817ZM134.207 150.872C137.479 148.878 142.127 151.738 141.817 155.478C141.9 159.397 136.647 161.899 133.602 159.328C130.659 157.314 131.017 152.474 134.207 150.872ZM143.399 173.216C141.941 171.057 143.653 168.451 146.011 167.956C147.915 168.334 149.93 169.744 149.524 171.903C149.249 174.838 144.89 175.732 143.399 173.223V173.216ZM70.448 171.339C71.0255 169.62 72.428 167.922 74.4836 168.369C77.4742 168.575 78.3611 173.016 75.7417 174.384C73.3905 175.945 70.6542 173.807 70.448 171.339ZM105.648 173.312C106.219 170.768 109.553 169.538 111.753 170.885C113.21 171.504 113.637 173.099 114.008 174.46C113.812 175.167 113.628 175.878 113.458 176.591C112.557 177.636 111.395 178.688 109.897 178.654C107.112 178.977 104.596 175.876 105.641 173.312H105.648Z"
                fill="black"
              />
            </g>
            <path
              d="M108.109 41.6626C111.402 39.9644 115.424 43.8901 113.678 47.1282C112.654 49.7682 108.797 50.4694 106.83 48.4551C104.747 46.5301 105.428 42.7076 108.109 41.6557V41.6626ZM72.6686 45.4163C74.6692 44.6051 77.2061 46.4063 76.9999 48.5582C77.2061 50.8819 74.3186 52.6007 72.2767 51.4938C69.5749 50.4626 69.8842 46.1451 72.6686 45.4163ZM145.255 51.5557C142.127 51.1844 141.632 46.3444 144.636 45.3682C146.974 44.2544 149.119 46.3513 149.462 48.5307C148.967 50.3869 147.386 52.0919 145.255 51.5557ZM80.733 60.2526C84.0811 58.1694 88.8524 61.2701 88.3367 65.0994C88.1649 68.9563 82.9536 71.1976 80.0111 68.5851C77.1649 66.5363 77.598 61.8338 80.733 60.2526ZM131.814 62.4663C133.306 58.6851 139.356 58.5613 141.054 62.2463C142.739 65.1132 140.669 68.6676 137.679 69.6438C133.712 70.3726 129.951 66.1513 131.814 62.4663ZM103.84 69.4307C103.805 66.1719 106.817 63.7519 109.959 63.5251C112.049 63.9376 114.317 64.8107 115.211 66.8801C116.882 69.7401 115.397 73.6657 112.392 74.9788C111.017 75.7351 109.381 75.4532 107.882 75.3638C105.593 74.2638 103.661 72.0844 103.84 69.4307ZM51.1361 74.1744C54.1955 72.3182 58.3205 75.6869 57.1586 78.9594C56.5261 81.7851 52.6624 82.9332 50.4555 81.1319C48.0974 79.4407 48.4686 75.3776 51.143 74.1676L51.1361 74.1744ZM164.312 74.1607C166.904 72.1807 171.187 74.4563 170.871 77.6738C171.05 80.6094 167.344 82.8301 164.773 81.3176C161.94 80.0594 161.645 75.7694 164.312 74.1676V74.1607ZM118.662 80.0113C122.939 78.4988 128.026 80.3069 130.46 84.0676C133.677 88.6532 131.972 95.6382 126.974 98.2713C121.804 101.386 114.249 98.7526 112.33 93.0601C110.165 87.9726 113.327 81.6063 118.656 80.0113H118.662ZM93.548 80.5132C98.2917 78.3132 104.679 80.1557 106.968 84.9269C109.663 89.5744 107.58 96.0438 102.76 98.4432C97.9342 101.145 91.1211 99.0963 88.7905 94.1119C86.1711 89.2857 88.4949 82.7338 93.548 80.5132ZM68.4061 88.9626C68.7705 85.9582 71.6511 83.9988 74.5592 83.7926C76.0759 83.9527 77.4933 84.6227 78.5798 85.6929C79.6663 86.7632 80.3575 88.1704 80.5405 89.6844C80.3342 92.7782 77.9074 95.7894 74.5799 95.7757C70.9155 96.0851 67.7049 92.4963 68.4061 88.9626ZM142.67 84.4526C146.43 82.3007 151.649 85.4288 151.484 89.6776C151.738 94.1807 145.963 97.3501 142.223 94.7101C138.332 92.5101 138.634 86.3226 142.67 84.4526ZM83.3386 100.313C87.7249 99.1238 92.7574 101.159 94.9092 105.133C97.2674 109.134 96.3049 114.689 92.6405 117.631C87.9311 121.935 79.2617 120.203 76.7592 114.331C73.8786 108.948 77.378 101.729 83.3317 100.306L83.3386 100.313ZM130.962 100.293C135.231 99.0894 140.25 100.705 142.546 104.534C145.585 108.914 144.134 115.452 139.617 118.271C134.874 121.55 127.545 119.831 124.932 114.703C121.77 109.402 124.953 101.908 130.962 100.293ZM55.0617 105.284C58.8567 103.874 63.0642 107.993 61.5243 111.698C60.5893 115.067 55.7561 116.318 53.2605 113.829C50.3386 111.492 51.418 106.301 55.0617 105.284ZM157.974 110.66C157.902 109.147 158.432 107.666 159.446 106.541C160.461 105.416 161.878 104.737 163.391 104.651C165.99 105.064 168.52 107.126 168.314 109.911C168.554 113.589 164.051 116.084 160.861 114.359C159.369 113.609 158.606 112.104 157.974 110.66ZM36.3961 107.113C38.6786 106.129 41.5042 108.075 40.9817 110.571C40.858 113.396 36.6161 114.489 35.0624 112.124C33.6874 110.481 34.5124 107.958 36.3961 107.106V107.113ZM180.42 107.051C182.029 105.93 184.614 106.734 185.247 108.584C186.326 110.605 184.346 113.369 182.036 113.032C178.791 113.321 177.746 108.46 180.42 107.051ZM95.7411 120.615C101.75 119.082 108.212 124.011 108.254 130.103C108.639 136.256 102.272 141.708 96.1261 140.291C91.3686 139.535 87.6355 135.025 87.7936 130.302C87.7799 125.778 91.2449 121.571 95.7411 120.615ZM119.542 120.608C125.64 118.931 132.295 123.949 132.199 130.178C132.522 136.214 126.355 141.488 120.333 140.284C114.661 139.569 110.481 133.444 112.062 128.026C112.86 124.424 115.926 121.495 119.542 120.601V120.608ZM73.6449 124.355C77.8661 123.647 81.8261 128.274 80.1142 132.22C78.863 136.428 72.648 137.562 69.898 134.131C66.6805 130.831 69.0867 124.809 73.6449 124.355ZM143.454 124.541C147.221 122.987 151.841 126.191 151.552 130.213C151.704 134.633 145.997 137.686 142.319 135.101C138.146 132.784 138.909 125.957 143.454 124.541ZM162.965 143.791C161.494 141.089 164.168 137.507 167.227 138.009C168.74 137.981 169.805 139.157 170.775 140.147C170.974 141.749 171.311 143.66 169.957 144.891C168.121 147.18 163.962 146.527 162.965 143.791ZM51.1224 138.758C53.9755 136.895 58.0799 139.679 57.4336 142.952C57.0899 145.86 53.3774 147.517 50.9367 145.867C48.3105 144.375 48.4067 140.119 51.1224 138.758ZM107.449 144.829C111.182 143.213 115.94 146.41 115.582 150.453C115.857 154.921 109.979 158.015 106.329 155.334C102.272 153.031 102.953 146.252 107.449 144.829ZM81.3655 150.817C84.5417 149.174 88.8042 152.013 88.5155 155.519C88.6117 158.393 85.7655 160.841 82.878 160.414C80.4924 160.366 78.9386 158.256 78.1686 156.255C78.2099 154.076 79.1242 151.649 81.3655 150.824V150.817ZM134.207 150.872C137.479 148.878 142.127 151.738 141.817 155.478C141.9 159.397 136.647 161.899 133.602 159.328C130.659 157.314 131.017 152.474 134.207 150.872ZM143.399 173.216C141.941 171.057 143.653 168.451 146.011 167.956C147.915 168.334 149.93 169.744 149.524 171.903C149.249 174.838 144.89 175.732 143.399 173.223V173.216ZM70.448 171.339C71.0255 169.62 72.428 167.922 74.4836 168.369C77.4742 168.575 78.3611 173.016 75.7417 174.384C73.3905 175.945 70.6542 173.807 70.448 171.339ZM105.648 173.312C106.219 170.768 109.553 169.538 111.753 170.885C113.21 171.504 113.637 173.099 114.008 174.46C113.812 175.167 113.628 175.878 113.458 176.591C112.557 177.636 111.395 178.688 109.897 178.654C107.112 178.977 104.596 175.876 105.641 173.312H105.648Z"
              fill="white"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_108_21"
              x="33.3779"
              y="40.7529"
              width="153.172"
              height="139.424"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="0.5" />
              <feGaussianBlur stdDeviation="0.5" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.204257 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_108_21"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_108_21"
                result="shape"
              />
            </filter>
            <clipPath id="clip0_108_21">
              <rect width="220" height="220" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      name: "AAVE",
      balance: 0,
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 220 220"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M110 216.7C168.929 216.7 216.7 168.929 216.7 110C216.7 51.071 168.929 3.2998 110 3.2998C51.0713 3.2998 3.30005 51.071 3.30005 110C3.30005 168.929 51.0713 216.7 110 216.7Z"
            fill="url(#paint0_linear_215_8)"
          />
          <path
            d="M156.695 152.515L120.615 65.2852C118.58 60.7752 115.555 58.5752 111.568 58.5752H108.378C104.39 58.5752 101.365 60.7752 99.3301 65.2852L83.6276 103.29H71.7476C68.2001 103.318 65.3126 106.178 65.2851 109.753V109.835C65.3126 113.383 68.2001 116.27 71.7476 116.298H78.1276L63.1401 152.515C62.8651 153.313 62.7001 154.138 62.7001 154.99C62.7001 157.025 63.3326 158.62 64.4601 159.858C65.5876 161.095 67.2101 161.7 69.2451 161.7C70.5926 161.673 71.8851 161.26 72.9576 160.463C74.1126 159.665 74.9101 158.51 75.5426 157.19L92.0426 116.27H103.483C107.03 116.243 109.918 113.383 109.945 109.808V109.643C109.918 106.095 107.03 103.208 103.483 103.18H97.3776L109.973 71.8027L144.293 157.163C144.925 158.483 145.723 159.638 146.878 160.435C147.95 161.233 149.27 161.645 150.59 161.673C152.625 161.673 154.22 161.068 155.375 159.83C156.53 158.593 157.135 156.998 157.135 154.963C157.163 154.138 157.025 153.285 156.695 152.515Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_215_8"
              x1="189.554"
              y1="43.0611"
              x2="30.7844"
              y2="176.649"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B6509E" />
              <stop offset="1" stop-color="#2EBAC6" />
            </linearGradient>
          </defs>
        </svg>
      ),
    },
    {
      name: "USDT",
      balance: 0,
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 220 220"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_108_407)">
            <path
              d="M110 220C170.751 220 220 170.751 220 110C220 49.2487 170.751 0 110 0C49.2487 0 0 49.2487 0 110C0 170.751 49.2487 220 110 220Z"
              fill="#26A17B"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M123.214 119.51V119.497C122.458 119.552 118.56 119.785 109.863 119.785C102.919 119.785 98.0311 119.579 96.3124 119.497V119.517C69.5824 118.342 49.6311 113.687 49.6311 108.118C49.6311 102.557 69.5824 97.9022 96.3124 96.7059V114.883C98.0586 115.007 103.064 115.303 109.98 115.303C118.278 115.303 122.437 114.959 123.214 114.89V96.7197C149.889 97.9091 169.792 102.563 169.792 108.118C169.792 113.687 149.889 118.328 123.214 119.51ZM123.214 94.8291V78.5628H160.435V53.7578H59.0911V78.5628H96.3124V94.8222C66.0624 96.2109 43.313 102.206 43.313 109.383C43.313 116.561 66.0624 122.549 96.3124 123.945V176.071H123.214V123.931C153.416 122.542 176.11 116.554 176.11 109.383C176.11 102.213 153.416 96.2247 123.214 94.8291Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_108_407">
              <rect width="220" height="220" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      name: "BCH",
      balance: 0,
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 220 220"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_108_2)">
            <path
              d="M220.47 110C220.47 131.756 214.018 153.023 201.931 171.113C189.844 189.202 172.665 203.301 152.565 211.627C132.465 219.952 110.348 222.131 89.0098 217.886C67.6719 213.642 48.0718 203.166 32.688 187.782C17.3043 172.398 6.82777 152.798 2.5834 131.46C-1.66098 110.122 0.517387 88.0047 8.84303 67.9048C17.1687 47.805 31.2676 30.6253 49.357 18.5383C67.4465 6.45139 88.7138 0 110.47 0C139.644 0 167.623 11.5893 188.252 32.2183C208.881 52.8473 220.47 80.8262 220.47 110Z"
              fill="#43A047"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M78.56 50.2297L103.84 56.9997L109.5 35.9297L122.14 39.3597L116.7 59.5497L127 62.3197L132.43 41.9197L145.29 45.3497L139.75 65.8697C139.75 65.8697 160.75 70.5197 165.7 87.5997C170.65 104.68 154.85 113.66 150 114C150 114 168.41 124.09 162.09 143.94C155.77 163.79 136.36 167.34 115.96 162.79L110.41 184.08L97.55 180.65L103.21 159.65L93 156.91L87.32 178L74.57 174.57L80.22 153.57L54.27 146.57L60.82 132.05C60.82 132.05 68.13 134.05 70.91 134.71C73.69 135.37 75.45 132.49 76.23 129.61C77.01 126.73 88.76 78.9997 89.87 75.0697C90.98 71.1397 90.53 68.0697 85.87 66.8597C81.21 65.6497 74.87 63.7597 74.87 63.7597L78.56 50.2297ZM104.06 113.44L97.06 141.27C97.06 141.27 131.76 153.8 136.2 136.17C140.64 118.54 104.06 113.44 104.06 113.44ZM107.28 100.24L114.15 74.7397C114.15 74.7397 143.87 80.0597 140.21 94.2497C136.55 108.44 119 103 107.28 100.24Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_108_2">
              <rect width="220" height="220" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      name: "XRP",
      balance: 0,
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 220 220"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_108_448)">
            <path
              d="M110 220C170.751 220 220 170.751 220 110C220 49.2487 170.751 0 110 0C49.2487 0 0 49.2487 0 110C0 170.751 49.2487 220 110 220Z"
              fill="#23292F"
            />
            <path
              d="M158.606 55H178.475L137.122 95.9544C129.892 103.078 120.15 107.071 110 107.071C99.8504 107.071 90.1081 103.078 82.8781 95.9544L41.4906 55H61.3938L92.8125 86.0956C97.3878 90.6115 103.558 93.1436 109.986 93.1436C116.415 93.1436 122.585 90.6115 127.16 86.0956L158.606 55ZM61.1531 168.871H41.25L82.8781 127.669C90.1081 120.545 99.8504 116.552 110 116.552C120.15 116.552 129.892 120.545 137.122 127.669L178.75 168.864H158.847L127.188 137.5C122.612 132.984 116.442 130.452 110.014 130.452C103.585 130.452 97.4153 132.984 92.84 137.5L61.1462 168.871H61.1531Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_108_448">
              <rect width="220" height="220" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      name: "XLM",
      balance: 0,
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 220 220"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_108_17)">
            <path
              d="M110 220.23C131.756 220.23 153.023 213.779 171.113 201.692C189.202 189.605 203.301 172.425 211.627 152.325C219.952 132.225 222.131 110.108 217.886 88.7701C213.642 67.4322 203.166 47.8321 187.782 32.4483C172.398 17.0645 152.798 6.58802 131.46 2.34365C110.122 -1.90073 88.0047 0.277641 67.9048 8.60328C47.805 16.9289 30.6253 31.0279 18.5383 49.1173C6.45139 67.2067 0 88.4741 0 110.23C0 139.404 11.5893 167.383 32.2183 188.012C52.8473 208.641 80.8262 220.23 110 220.23Z"
              fill="white"
            />
            <path
              d="M163 61.6102L145.23 70.6102L59.44 114.31C58.2316 104.928 59.6511 95.3935 63.5404 86.7698C67.4297 78.146 73.6361 70.7709 81.4686 65.4656C89.3012 60.1603 98.4525 57.1329 107.904 56.7206C117.355 56.3083 126.735 58.5272 135 63.1302L145.15 58.0002L146.67 57.2302C137.359 50.4708 126.361 46.4165 114.89 45.5151C103.419 44.6137 91.9229 46.9003 81.6703 52.1224C71.4176 57.3444 62.8078 65.2986 56.7919 75.1065C50.7759 84.9144 47.5879 96.1943 47.58 107.7C47.58 109.29 47.64 110.87 47.76 112.45C47.9294 114.688 47.4342 116.925 46.3365 118.882C45.2388 120.839 43.5876 122.428 41.59 123.45L36.23 126.18V138.93L52.02 130.93L57.13 128.32L62.13 125.75L152.6 79.6102L162.77 74.4402L183.77 63.7302V51.0002L163 61.6102Z"
              fill="black"
            />
            <path
              d="M183.77 76.4902L67.3 135.79L57.14 141L36.23 151.64V164.38L57 153.79L74.76 144.79L160.64 101C160.928 103.225 161.072 105.467 161.07 107.71C161.056 116.618 158.716 125.367 154.28 133.091C149.844 140.815 143.466 147.246 135.78 151.747C128.093 156.248 119.364 158.662 110.457 158.75C101.55 158.838 92.7744 156.598 85 152.25L84.38 152.58L73.38 158.2C82.6932 164.961 93.6942 169.016 105.167 169.916C116.641 170.816 128.139 168.527 138.393 163.301C148.647 158.076 157.256 150.117 163.27 140.305C169.284 130.493 172.468 119.209 172.47 107.7C172.47 106.1 172.41 104.49 172.29 102.91C172.116 100.673 172.608 98.4349 173.704 96.4773C174.8 94.5197 176.452 92.9305 178.45 91.9102L183.82 89.1802L183.77 76.4902Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0_108_17">
              <rect width="220" height="220" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
  ];
  return (
    <CryptoExchangeWrapper>
      <h1
        style={convertInlineStyles(
          "color: #343a40; line-height: 1.4; font-size: 1.725rem; font-weight: 500;"
        )}
      >
        Crypto Exchange
      </h1>
      <BalanceCardWrapper>
        {cardData.map((data, index) => (
          <BalanceCard data={data} key={index} />
        ))}
      </BalanceCardWrapper>
      <ExchangeWrapper>
        <TradingViewWrapper>
          <div id="tradingview_f933e">
            <div
              id="tradingview_973b1-wrapper"
              style={convertInlineStyles(
                'position: relative; box-sizing: content-box; font-family: -apple-system, BlinkMacSystemFont, "Trebuchet MS", Roboto, Ubuntu, sans-serif; margin: 0px auto !important; padding: 0px !important; width: 100%; height: calc(368px);'
              )}
            >
              <iframe
                title="advanced chart TradingView widget"
                lang="en"
                id="tradingview_973b1"
                frameborder="0"
                allowtransparency="true"
                allowfullscreen="true"
                src="https://s.tradingview.com/widgetembed/?hideideas=1&amp;overrides=%7B%7D&amp;enabled_features=%5B%5D&amp;disabled_features=%5B%5D&amp;locale=en#%7B%22symbol%22%3A%22BINANCE%3ABTCUSD%22%2C%22frameElementId%22%3A%22tradingview_973b1%22%2C%22interval%22%3A%221%22%2C%22hide_side_toolbar%22%3A%220%22%2C%22allow_symbol_change%22%3A%221%22%2C%22save_image%22%3A%221%22%2C%22studies%22%3A%22%5B%5D%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%229%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22studies_overrides%22%3A%22%7B%7D%22%2C%22utm_source%22%3A%22stakecornservices.finance%22%2C%22utm_medium%22%3A%22widget_new%22%2C%22utm_campaign%22%3A%22chart%22%2C%22utm_term%22%3A%22BINANCE%3ABTCUSD%22%2C%22page-uri%22%3A%22stakecornservices.finance%2Fdashboard%2Fasset-balance%22%7D"
                style={convertInlineStyles(
                  "width: 100%; height: 100%; margin: 0px !important; padding: 0px !important;"
                )}
              ></iframe>
            </div>
          </div>
          <div
            className="tradingview-widget-copyright"
            style={convertInlineStyles("width: 100%;")}
          >
            <a href="/#" rel="noopener" target="_blank">
              <span className="blue-text"></span>{" "}
              <span className="blue-text">Personal trading chart</span>
            </a>
          </div>
        </TradingViewWrapper>
        <ExchangeFormWrapper>
          <ExchangeForm>
            <ExchangeFormGroup>
              <h5 style={{ marginBlockStart: "0px" }}>Source Account</h5>
              <ExchangeFormSelect
                className="form-control text-dark bg-light"
                name="source"
                id="sourceasset"
              >
                <option value="btc">BTC</option>
                <option value="link">LINK</option>
                <option value="bnb">BNB</option>
                <option value="ada">ADA</option>
                <option value="aave">AAVE</option>
                <option value="xlm">XLM</option>
                <option value="xrp">XRP</option>
                <option value="ltc">LTC</option>
                <option value="bch">BCH</option>
                <option value="eth">ETH</option>
                <option value="usdt">USDT</option>
                <option value="usd">USD</option>
              </ExchangeFormSelect>
            </ExchangeFormGroup>
            <ExchangeFormGroup>
              <h5 style={{ marginBlockStart: "0px" }}>Destination Account</h5>
              <ExchangeFormSelect
                name="destination"
                className="form-control text-dark bg-light"
                id="destinationasset"
              >
                <option value="usd">USD</option>
                <option value="btc">BTC</option>
                <option value="link">LINK</option>
                <option value="bnb">BNB</option>
                <option value="ada">ADA</option>
                <option value="aave">AAVE</option>
                <option value="xlm">XLM</option>
                <option value="xrp">XRP</option>
                <option value="ltc">LTC</option>
                <option value="bch">BCH</option>
                <option value="eth">ETH</option>
                <option value="usdt">USDT</option>
              </ExchangeFormSelect>
            </ExchangeFormGroup>
            <ExchangeFormGroup>
              <h5 style={{ marginBlockStart: "0px" }}>Amount</h5>
              <ExchangeFormInput
                type="text"
                name="amount"
                className="form-control text-dark bg-light"
                placeholder="Enter amount of btc"
                id="amount"
              />
            </ExchangeFormGroup>
            <ExchangeFormGroup>
              <h5 style={{ marginBlockStart: "0px" }}>You will get</h5>
              <ExchangeFormInput
                type="text"
                className="form-control text-dark bg-light"
                placeholder="Quantity of link"
                id="quantity"
              />
            </ExchangeFormGroup>
            <ExchangeFormInput
              type="hidden"
              id="realquantity"
              name="quantity"
            />
            <ExchangeFormGroup>
              <span className="mb-1 ml-2 caption">
                <span className="text-dark">
                  <b>Fees = 2%</b>
                </span>
              </span>
            </ExchangeFormGroup>
            <div>
              <ExchangeFormButton type="submit">Exchange</ExchangeFormButton>
            </div>
          </ExchangeForm>
        </ExchangeFormWrapper>
      </ExchangeWrapper>
    </CryptoExchangeWrapper>
  );
};

export default CryptoExchange;
